// src/components/BackgroundGlow.js
import React from 'react';
import { motion } from 'framer-motion';

const BackgroundGlow = ({ intensity = 'medium' }) => {
  const blobs =
    intensity === 'high'
      ? [
          { size: 600, x: '-10%', y: '-20%', opacity: 0.28 },
          { size: 500, x: '70%', y: '10%', opacity: 0.24 },
          { size: 400, x: '30%', y: '70%', opacity: 0.22 },
        ]
      : [
          { size: 500, x: '-15%', y: '-25%', opacity: 0.22 },
          { size: 400, x: '65%', y: '15%', opacity: 0.18 },
        ];

  return (
    <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
      {/* BLOBS GRANDES */}
      {blobs.map((blob, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full bg-orange-500 blur-[160px]"
          style={{
            width: blob.size,
            height: blob.size,
            left: blob.x,
            top: blob.y,
            opacity: blob.opacity,
          }}
          animate={{
            x: [0, 40, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 18 + i * 6,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}

      {/* GRADIENTE SUAVE (NO MATA EL GLOW) */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/5 to-black/15" />
    </div>
  );
};

export default BackgroundGlow;
